import { handleActions } from 'redux-actions';

import checkPermissions from '../../../shared/check-permissions';
import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';

export const namespace = 'offerLangRulesEdit';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

const initialFormValues = {};

function mapResponseDataToStateData(data) {
	return {
		...data.reduce((acc, value) => ({ ...acc, [`rules_${value.rules_lang}`]: value.rules }), {}),
		campaign_lang: [data[0].campaign_lang]
	};
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const lang = props.params.lang;

			if (!lang) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: endpoints.LANG_RULES.SINGLE.replace('{lang}', lang),
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch, getState) => {
			console.log(values);

			const payload = selectors.getLanguages(getState()).map((lang) => ({
				campaign_lang: values.campaign_lang[0],
				rules_lang: lang.id,
				rules: values[`rules_${lang.id}`] || values['rules_en']
			}));

			dispatch(actions.own.toggleProgressBar());

			const request = http({
				url: endpoints.LANG_RULES.BASE,
				method: 'post',
				actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
				data: { data: payload }
			});

			return request(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getLandingLanguages: (state) => state.root.lists['landing-languages'],
	getLanguages: (state) => state.root.lists['languages'],
	getCan: (state) => checkPermissions(state, { edit: 'offers_create' })
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/lang-rules/edit/index.js